import { render } from "./Navigation.vue?vue&type=template&id=299fbbde&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=299fbbde&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-299fbbde"

export default script